import React from 'react';
import { Box } from '@material-ui/core';
import PhoneInput from 'react-phone-input-2';
import PropTypes from 'prop-types';
import 'react-phone-input-2/lib/style.css';

import './style.css';
const Input = (props) => {
  return (
    <Box>
      <PhoneInput
        specialLabel={''}
        country={'my'}
        onlyCountries={['my', 'sg', 'id']}
        countryCodeEditable={false}
        inputStyle={{
          width: '100%',
          height: 'auto',
          borderColor: props.touched && props.error && 'red',
        }}
        buttonStyle={{
          backgroundColor: 'transparent',
        }}
        {...props}
        onChange={props.onChange}
      />
      {props.touched && props.error && (
        <p
          style={{ color: 'red' }}
          className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error MuiFormHelperText-filled MuiFormHelperText-marginDense"
        >
          {props.error}
        </p>
      )}
    </Box>
  );
};

const index = (props) => {
  return (
    <Input
      label={'Mobile Phone'}
      req={true}
      helperText={''}
      error={true}
      isSelect={false}
      onChange={props.onChange}
      {...props.input}
      {...props.meta}
      {...props.custom}
    />
  );
};

Input.propTypes = {
  touched: PropTypes.bool,
  error: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
};

export default index;
